import { AddStaticText } from "../utils/AddStaticText";
import { DetermineTextColor } from "../utils/DetermineTextColor";
import { kDefaultPromptHeight, kDefaultPromptWidth, kEscKey } from "../constants";
import { QPanel } from "./QPanel";
import { removeAllChildNodes } from "../utils/removeAllChildNodes";
import { uFramelessPanelColor, uFramelessPanelColorDarker } from "../whitelabel/brand";
import { QCmd } from "./QCmd";

export class HSlideShow extends QPanel {
  constructor() {
    super();
    this.fUseTheme = true;
  }

  InitSlideShow(wsMgr, slideList) {
    this.fWSMgr = wsMgr;
    this.fZLayer = "18";
    this.fUIColors = wsMgr.GetUIColors();
    this.fSlideList = slideList;
    var w = kDefaultPromptWidth;
    var h = kDefaultPromptHeight;
    var myApp = window["MyApp"];
    if (myApp) {
      h = myApp.GetDefaultWindowHeight();
      w = h + 200;
    }
    this.SizePanel(w, h);
    this.CenterOnBackgroundPanel();
    AddStaticText(this, 0, 0, "", false, this.fUIColors.GetBodyTextColor());
    this.SetupHTMLPanel();
    this.SetFloatingPanelFrameAndFill();
    this.fWSMgr.PushPanel(this);
    this.fWSMgr.SetKeyboardTarget(null, this);
  }

  GetSlideList() {
    return this.fSlideList;
  }

  InvertThemeTextColors() {
    if (!this.fUseTheme) return false;
    return DetermineTextColor(uFramelessPanelColor) === "#111111";
  }

  AddCloseButton(slideShow) {
    var closeButtonClass = "btn-close";
    var textColor = this.fUseTheme ? DetermineTextColor(uFramelessPanelColor) : "#F2F2F2";
    if (textColor === "#F2F2F2") closeButtonClass += " btn-close-white";
    var removeButton = document.createElement("button");
    removeButton.setAttribute("class", closeButtonClass + " btn-sm");
    removeButton.setAttribute("aria-label", "Close");
    removeButton.style.float = "right";
    removeButton.fCallbackObj = this;
    removeButton.fWSMgr = this.fWSMgr;
    removeButton.style.marginRight = "10px";
    removeButton.style.marginTop = "5px";
    removeButton.style.marginBottom = "5px";

    removeButton.fWSMgr = this.fWSMgr;
    removeButton.addEventListener("click", function (event) {
      this.fCallbackObj.ExitPrompt();
      this.fWSMgr.PrepRenderWS();
      this.fWSMgr.RenderWS();
    });
    slideShow.appendChild(removeButton);
  }

  SetupHTMLPanel() {
    var imageMgr = this.fWSMgr.GetImageMgr();

    var slideList = this.GetSlideList();

    var slideShow = document.createElement("div");
    slideShow.setAttribute("id", "slideShow");
    slideShow.setAttribute("class", "carousel slide carousel-fade");
    slideShow.setAttribute("data-bs-ride", "carousel");
    slideShow.fCallbackObj = this;
    slideShow.addEventListener("keyup", function (e) {
      if (e.keyCode == kEscKey) {
        this.fCallbackObj.ExitPrompt();
        this.fCallbackObj.fWSMgr.PrepRenderWS();
        this.fCallbackObj.fWSMgr.RenderWS();
      }
    });
    if (this.fUseTheme) slideShow.style.backgroundColor = uFramelessPanelColorDarker;

    var buffer = 5;

    slideShow.style.top = this.GetPositionY() - buffer + "px";
    slideShow.style.left = this.GetPositionX() - buffer + "px";
    slideShow.style.width = this.GetWidth() + buffer * 2 + "px";
    slideShow.style.height = this.GetHeight() + buffer * 2 + "px";
    slideShow.style.zIndex = this.GetZLayer();

    this.AddCloseButton(slideShow);

    var indicators = document.createElement("div");
    indicators.setAttribute("class", "carousel-indicators");

    for (var i in slideList) {
      var indictorButton = document.createElement("button");
      indictorButton.setAttribute("type", "button");
      indictorButton.setAttribute("data-bs-target", "#slideShow");
      indictorButton.setAttribute("data-bs-slide-to", i.toString());
      indictorButton.setAttribute("aria-current", "true");
      indictorButton.setAttribute("aria-label", "Slide " + i.toString());

      // invert text color for indicator buttons (theme mode only)
      if (this.InvertThemeTextColors()) indictorButton.style.filter = "invert(100%)";

      if (i == 0) indictorButton.classList.add("active");

      indicators.appendChild(indictorButton);
    }

    slideShow.appendChild(indicators);

    var slideShowInner = document.createElement("div");
    slideShowInner.setAttribute("class", "carousel-inner");
    slideShowInner.style.height = "100%";

    var videoQueue = [];
    for (var i in slideList) {
      var aSlide = slideList[i];

      var slideShowItem = document.createElement("div");
      slideShowItem.setAttribute("class", "carousel-item");
      slideShowItem.setAttribute("data-bs-interval", "0");
      slideShowItem.style.width = "100%";
      slideShowItem.style.height = "100%";

      // invert fill color for indicator buttons (theme mode only)
      if (this.fUseTheme) slideShowItem.style.backgroundColor = uFramelessPanelColorDarker;

      if (i == 0) slideShowItem.classList.add("active");

      if (aSlide["imagePath"] || aSlide["preloadedImageIdx"]) {
        var slideShowImg = document.createElement("img");
        var imageSrc;
        if (aSlide["imagePath"]) {
          imageSrc = aSlide["imagePath"];
        } else if (aSlide["preloadedImageIdx"]) {
          var appImage = imageMgr.GetIndexImage(aSlide["preloadedImageIdx"]);
          imageSrc = appImage.src;
        }
        slideShowImg.setAttribute("src", imageSrc);
        slideShowImg.style.padding = "0px 20px 60px 20px";
        slideShowItem.appendChild(slideShowImg);
      }

      if (aSlide["videoPath"]) {
        var slideVideo = document.createElement("video");
        slideVideo.setAttribute("autoplay", ""); // tell browser to start video automatically
        slideVideo.setAttribute("loop", ""); // loop video instead of stopping
        slideVideo.setAttribute("muted", ""); // mute any audio. some browsers wont auto-play if not muted.
        slideVideo.setAttribute("controls", "");
        var videoSrc = aSlide["videoPath"];
        slideVideo.setAttribute("src", videoSrc);
        slideVideo.setAttribute("type", "video/webm");
        slideVideo.setAttribute("class", "video");
        slideVideo.style.padding = "0px 20px 60px 20px";

        videoQueue.push(slideVideo);

        slideShowItem.appendChild(slideVideo);
      }

      var slideCaption = document.createElement("div");
      slideCaption.setAttribute("class", "carousel-caption d-none d-md-block");

      if (aSlide["header"]) {
        var slideHeader = document.createElement("h5");
        slideHeader.innerText = aSlide["header"];
        if (this.fUseTheme) slideHeader.style.color = DetermineTextColor(uFramelessPanelColor);

        slideCaption.appendChild(slideHeader);
      }

      if (aSlide["body"]) {
        var slideBodyMsg = document.createElement("p");
        slideBodyMsg.innerHTML = aSlide["body"];
        if (this.fUseTheme) slideBodyMsg.style.color = DetermineTextColor(uFramelessPanelColor);

        slideCaption.appendChild(slideBodyMsg);
      }

      slideShowItem.appendChild(slideCaption);

      slideShowInner.appendChild(slideShowItem);
    }

    slideShow.appendChild(slideShowInner);

    var prevButton = document.createElement("button");
    prevButton.setAttribute("class", "carousel-control-prev");
    prevButton.setAttribute("type", "button");
    prevButton.setAttribute("href", "#slideShow");
    prevButton.setAttribute("data-bs-slide", "prev");
    prevButton.setAttribute("id", "carousel-slide-prev");
    if (this.InvertThemeTextColors()) prevButton.style.filter = "invert(100%)";

    var prevSpan1 = document.createElement("span");
    prevSpan1.setAttribute("class", "carousel-control-prev-icon");
    prevSpan1.setAttribute("aria-hidden", "true");

    var prevSpan2 = document.createElement("span");
    prevSpan2.setAttribute("class", "visually-hidden");
    prevSpan2.innerText = "Previous";

    prevButton.appendChild(prevSpan1);
    prevButton.appendChild(prevSpan2);

    slideShow.appendChild(prevButton);

    var nextButton = document.createElement("button");
    nextButton.setAttribute("class", "carousel-control-next");
    nextButton.setAttribute("type", "button");
    nextButton.setAttribute("id", "carousel-slide-next");
    nextButton.setAttribute("href", "#slideShow");
    nextButton.setAttribute("data-bs-slide", "next");
    if (this.InvertThemeTextColors()) nextButton.style.filter = "invert(100%)";

    var nextSpan1 = document.createElement("span");
    nextSpan1.setAttribute("class", "carousel-control-next-icon");
    nextSpan1.setAttribute("aria-hidden", "true");

    var nextSpan2 = document.createElement("span");
    nextSpan2.setAttribute("class", "visually-hidden");
    nextSpan2.innerText = "Next";

    nextButton.appendChild(nextSpan1);
    nextButton.appendChild(nextSpan2);

    slideShow.appendChild(nextButton);
    slideShow.fVideoQueue = videoQueue;

    document.body.appendChild(slideShow);

    // Reset videos on slide change (if videos used in slide show)
    if (videoQueue.length > 0) {
      // $("#slideShow").on("slide.bs.carousel", function (e) {
      //   for (var vid of this.fVideoQueue) {
      //     vid.pause();
      //     vid.currentTime = 0;
      //     vid.play();
      //   }
      // });
    }

    this.fSlideShow = slideShow;
  }

  ExitPrompt() {
    this.fWSMgr.MarkCurrentContextPromptAsRead();
    this.NukePanel();
  }

  PanelHandleKeyboard(keyInfo, targetElement, wsMgr) {
    var handled = true;
    var keyCode = keyInfo.keyCode;
    // slides class has native support for paging left / right with any key press
    switch (keyCode) {
      case kEscKey:
        var aCmd = new QCmd();
        aCmd.InitCommand("CNCL", targetElement, this, wsMgr, wsMgr.GetDoc());
        this.ExecuteCommand(aCmd);
        break;
      default:
        handled = false;
        break;
    }
    return handled;
  }

  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var handled = true;

    switch (cmdCode) {
      case "CNCL":
        this.ExitPrompt();
        break;
      default:
        handled = false;
    }

    return handled;
  }

  PostStandardResize() {
    this.CenterOnBackgroundPanel();
    var buffer = 5;

    this.fSlideShow.style.top = this.GetPositionY() - buffer + "px";
    this.fSlideShow.style.left = this.GetPositionX() - buffer + "px";
  }

  DoClosePanel() {
    var htmlPanel = document.getElementById("slideShow");
    if (htmlPanel) {
      removeAllChildNodes(htmlPanel, true);
    }
  }
}
